
import config from '../../config.json';
import { useEffect, useState } from 'react';
import { AddUpdateCart, GetCart } from '../../Utility/CartUtility';
import { ProductModel } from '../../Model/ProductModel';
import { useNavigate } from 'react-router-dom';

const Product = (props: any) => {

    const navigate = useNavigate();

    const [ProductList, setProductList] = useState<ProductModel[]>([]);

    useEffect(()=>{
        
        setProductList(props?.ProductList);

    },[props]);


    const addToCart = (actionType: any, _Item_Id: any, _Item_Title: any, _Quantity: any, _Seller_Price: any, _Seller_Id: any, _Item_Title_Url : any) => {

        const response = AddUpdateCart(actionType, _Item_Id, _Item_Title, _Quantity, _Seller_Price, _Seller_Id,0, _Item_Title_Url);
        $("#CartText").text(GetCart().length);

        navigate('/Cart');

    }



    return (<>

        {
            ProductList?.map(item => (
                <div className="swiper-slide">
                    <div className="shop-box-items style-2">
                        <div className="book-thumb center">
                            <a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}><img src={config?.ThumbImageBaseUrl + item?.Image_Link} alt="img" /></a>
                        </div>
                        <div className="shop-content">
                            <h3><a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}>{item?.Item_Title}</a></h3>
                            <h5> Publish Year: {item?.Release_Date} </h5>
                            <ul className="price-list">
                                <li>Price: {item?.Seller_Price}</li>
                                <li>
                                    <del>₹ {item?.Base_Price}</del>
                                </li>
                            </ul>
                        </div>
                        <div className="shop-button">

                            {
                                (item?.Stock_Status === "PreOrder" || item?.Stock_Status === "In Stock" ||
                                    item?.Stock_Status === "In Stock" || item?.Stock_Status === "Avaliable") && (
                                    <>
                                        <a className="theme-btn crtbtn" onClick={() => addToCart('Add', item?.Item_Id, item?.Item_Title, 1, item?.Seller_Price, item.Seller_Id, item?.Item_Title_Url)} ><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                        <a className="theme-btn crtbtn" onClick={() => addToCart('Add', item?.Item_Id, item?.Item_Title, 1, item?.Seller_Price, item.Seller_Id, item?.Item_Title_Url)}  ><i className="fa-solid fa-list"></i> Buy Now</a>
                                    </>)
                            }

                            {
                                (item?.Stock_Status === "Permanently Discountinued" || item?.Stock_Status === "Termprory Unavailable" ||
                                    item?.Stock_Status === "Out of Stock" ) && (
                                    <>
                                       <span>{item?.Stock_Status}</span>
                                    </>)
                            }

                        </div>
                    </div>
                </div>
            ))
        }

    </>);



}

export default Product;